import styled from "@emotion/styled";
import React from "react";

type Props = {
  prize: string;
  prizeImage: string;
  size: number;
};

export default function RafflePrizeImage(props: Props) {
  return (
    <Root>
      <ImageWrapper size={props.size}>
        <img src={props.prizeImage} alt={props.prize} />
      </ImageWrapper>
    </Root>
  );
}

const Root = styled.div`
  text-align: center;
`;

const ImageWrapper = styled.div<{ size: number }>`
  position: relative;
  margin: 12px auto 40px auto;
  display: inline-flex;
  justify-content: center;

  img {
    max-height: ${(props) => props.size}px;
    z-index: 1;
  }
`;
